const isValidEmail = (email) => {
  const emailRegex = /^\S+@\S+\.\S+$/;
  return emailRegex.test(email);
};

const isValidPhoneNumber = (phone) => {
  const phoneRegex = /^((00|\+)?47)?\d{8}$/;
  return phoneRegex.test(phone.replace(/ /g, ''));
};

const isValidZip = (zip) => {
  const zipRegex = /^\d{4}$/;
  return zipRegex.test(zip);
};

const isValidName = (name) => {
  return name ? true : false;
};

export { isValidEmail, isValidPhoneNumber, isValidZip, isValidName };
